import { MiniatureCards } from "/react4xp/parts/miniature-cards/miniature-cards";

export default (props) => <MiniatureCards {...props} />